import React from 'react';
import { StudentQAModel } from '../../../../models';
import { Calendar, MessageSquare, Trash2, ChevronRight } from 'lucide-react';

interface StudentQACardProps {
    qa: StudentQAModel;
    onView: () => void;
    onDelete: (e: React.MouseEvent) => void;
}

const StudentQACard: React.FC<StudentQACardProps> = ({ qa, onView, onDelete }) => {
    const formatDate = (ts: number) => {
        const date = new Date(ts);
        return `${date.getFullYear()}.${date.getMonth() + 1}.${date.getDate()} ${date.getHours()}:${String(date.getMinutes()).padStart(2, '0')}`;
    };

    return (
        <button
            onClick={onView}
            className="w-full bg-white rounded-xl border border-slate-100 hover:border-indigo-200 transition-all cursor-pointer overflow-hidden shadow-sm hover:shadow-md text-left"
        >
            <div className="p-4 flex items-center gap-4">
                <div className="w-10 h-10 rounded-xl bg-indigo-600 text-white flex items-center justify-center shrink-0 shadow-sm">
                    <MessageSquare size={18} />
                </div>
                <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-1">
                        <div className="flex items-center gap-1 text-[10px] font-bold text-slate-300">
                            <Calendar size={10} />
                            {formatDate(qa.createdAt)}
                        </div>
                    </div>
                    <h4 className="text-sm font-bold text-slate-800 truncate">
                        {qa.question}
                    </h4>
                </div>
                <div className="flex items-center gap-2">
                    <button
                        onClick={onDelete}
                        className="w-8 h-8 rounded-lg bg-slate-50 text-slate-300 hover:bg-rose-50 hover:text-rose-500 transition-all flex items-center justify-center"
                    >
                        <Trash2 size={16} />
                    </button>
                    <div className="text-slate-300">
                        <ChevronRight size={18} />
                    </div>
                </div>
            </div>
        </button>
    );
};

export default StudentQACard;
